import { useMutation } from '@tanstack/react-query';
import { createCheckoutSession } from '@api/billing';

export function useCheckoutSession() {
  return useMutation({
    mutationFn: createCheckoutSession,
  });
}
